/* Funcion que setea publicidad_perfilada_aceptada si/no dependiendo del checked */
export function handleCheckboxChange() {

  const observer = new MutationObserver(() => {

    const checkboxes = document.querySelectorAll(".cbox_publicidad_aceptada");
    const hiddenInputs = document.querySelectorAll(".publicidad_perfilada_aceptada");

    if (checkboxes.length) {

      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", (event) => {
          if (event.target.checked) {
            if (hiddenInputs.length) {

              hiddenInputs.forEach(elementInput => {
                elementInput.value = "si";
              });
            }
            window.userLabels.EDeclaratives.publicidad_perfilada_aceptada = "si";
          } else {
            if (hiddenInputs.length) {

              hiddenInputs.forEach(elementInput => {
                elementInput.value = "no";
              });
            }
            window.userLabels.EDeclaratives.publicidad_perfilada_aceptada = "no";
          }
        });
      });

      const observerTime = setTimeout(() => {
        observer.disconnect();
        clearTimeout(observerTime);
      }, 2000);
    }

  });

  observer.observe(document.body, { childList: true, subtree: true });

}